
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authors",
      function () {
        return require("private-next-pages/authors/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authors"])
      });
    }
  